'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _components = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Find_Evidences = (_temp = _class = function (_React$Component) {
  (0, _inherits3.default)(Find_Evidences, _React$Component);

  function Find_Evidences(props) {
    (0, _classCallCheck3.default)(this, Find_Evidences);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Find_Evidences.__proto__ || (0, _getPrototypeOf2.default)(Find_Evidences)).call(this, props));

    _this.state = {
      currentPhoto: 1,
      photo1: {
        numberPoints: 1,
        minPoints: 1
      },
      photo2: {
        numberPoints: 5,
        minPoints: 3
      },
      photo3: {
        numberPoints: 2,
        minPoints: 2
      },
      maxPoints: 5,
      isWrong: false

    };
    return _this;
  }

  (0, _createClass3.default)(Find_Evidences, [{
    key: 'showFade',
    value: function showFade() {
      document.getElementsByClassName('fadeLayerOp')[0].classList.add('visible');

      setTimeout(function () {
        document.getElementsByClassName('fadeLayerOp')[0].classList.remove('visible');
      }.bind(this), 900);
    }
  }, {
    key: 'nextPhoto',
    value: function nextPhoto() {
      this.showFade();

      //le kitamos la clase ok a los puntos,
      //la capa de resolucion de la prueba y los círculos visibles, cuando está a medias el show fade
      setTimeout(function () {

        var pointsOk = document.getElementsByClassName('point');

        for (var i = 0; i < pointsOk.length; ++i) {
          pointsOk[i].classList.remove('ok');
          pointsOk[i].getElementsByTagName('i')[0].classList.remove('visible', 'icon-missil-big');
          pointsOk[i].getElementsByClassName('circlesAndIcon')[0].classList.remove('show');
          document.getElementsByClassName('resolutionPoints')[0].classList.remove('visible');
        }

        this.setState({
          currentPhoto: this.state.currentPhoto + 1
        });

        document.getElementsByClassName('titleBottom')[0].classList.add('elementToFadeOut');
        document.getElementsByClassName('instrucctionsPhoto')[0].classList.remove('elementToFadeOut');
        document.getElementsByClassName('instrucctionsPhoto')[0].classList.remove('hidden');
      }.bind(this), 800);
    }
  }, {
    key: 'goPhoto',
    value: function goPhoto() {
      this.refs.instrucctionsPhoto.classList.add('elementToFadeOut');
      document.getElementsByClassName('titleBottom')[0].classList.remove('elementToFadeOut');

      setTimeout(function () {
        var layer = document.getElementsByClassName('instrucctionsPhoto');
        layer[0].classList.add('hidden');
      }, 1000);
    }
  }, {
    key: 'checkClickPhoto',
    value: function checkClickPhoto(ev) {
      var elem = ev.target;
      if (elem.className == 'point') {
        this.correctClick(elem);
      } else {
        !elem.classList.contains('ok') ? this.wrongClick() : null;
      }
    }
  }, {
    key: 'correctClick',
    value: function correctClick(elem) {
      elem.classList.add('ok');
      elem.getElementsByTagName('i')[0].classList.add('icon-missil-big');
      elem.getElementsByTagName('i')[0].classList.add('visible');

      this.checkAllPoints();
    }
  }, {
    key: 'wrongClick',
    value: function wrongClick() {
      var _this2 = this;

      this.refs.photo.classList.add('failCombination');

      setTimeout(function () {
        document.getElementsByClassName('failCombination')[0].classList.remove('failCombination');
      }.bind(this), 620);

      /*Mostramos texto de error*/
      this.setState({
        isWrong: true
      }, function () {

        setTimeout(function () {
          this.setState({ isWrong: false });
        }.bind(_this2), 3000);
      });
    }
  }, {
    key: 'checkAllPoints',
    value: function checkAllPoints() {
      var points = document.getElementsByClassName('point ok');
      var actualPhoto = 'photo' + this.state.currentPhoto;

      if (points.length == this.state[actualPhoto].minPoints) {
        setTimeout(function () {
          //document.getElementsByClassName('resolutionPoints')[0].classList.remove('withOpacity');
          document.getElementsByClassName('resolutionPoints')[0].classList.add('visible');
          document.getElementsByClassName('resolutionPoints')[0].classList.add('withOpacity');
        }.bind(this), 1000);

        for (var i = 0; i < points.length; ++i) {
          points[i].getElementsByClassName('circlesAndIcon')[0].classList.add('show');
        }
      }
      //else{
      //  console.log('continuamos buscando puntos')
      //}
    }
  }, {
    key: 'render',
    value: function render() {

      var txt = this.props.interactionTxt;
      var txtCase = this.props.interactionTxt['photo' + this.state.currentPhoto];
      var buttonStart = this.props.buttonStart;
      var buttonContinue = this.props.buttonContinue;
      var wrongText = this.props.wrongText;

      var isWrong = this.state.isWrong ? 'show' : 'hide';

      return _react2.default.createElement(
        'div',
        { className: 'evidencesInteraction photo' + this.state.currentPhoto },
        _react2.default.createElement(
          'div',
          { className: 'instrucctionsPhoto', ref: 'instrucctionsPhoto' },
          _react2.default.createElement(
            'div',
            { className: 'table' },
            _react2.default.createElement(
              'div',
              { className: 'cell' },
              _react2.default.createElement(_components.PointsAndSvg, { cName: this.state.currentPhoto, icon: 'icon-warning', clickIcon: this.goPhoto.bind(this) }),
              _react2.default.createElement(
                'p',
                { className: 'first' },
                txtCase.title
              ),
              _react2.default.createElement(
                'p',
                { className: 'second' },
                txtCase.subtitle
              ),
              _react2.default.createElement(
                'div',
                { onClick: this.goPhoto.bind(this), className: "nextView " + this.props.caseId },
                _react2.default.createElement(
                  'span',
                  null,
                  buttonContinue
                ),
                _react2.default.createElement('i', { className: 'icon-arrowright' })
              )
            )
          ),
          _react2.default.createElement('div', { className: 'opacityCover' })
        ),
        _react2.default.createElement(
          'div',
          { className: 'photo', ref: 'photo', onClick: this.checkClickPhoto.bind(this) },
          _react2.default.createElement(
            'span',
            { className: 'point' },
            _react2.default.createElement(
              'div',
              { className: 'circlesAndIcon' },
              _react2.default.createElement('i', { className: '' }),
              _react2.default.createElement(
                'div',
                { className: 'circles' },
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto })
              )
            )
          ),
          _react2.default.createElement(
            'span',
            { className: 'point' },
            _react2.default.createElement(
              'div',
              { className: 'circlesAndIcon' },
              _react2.default.createElement('i', { className: '' }),
              _react2.default.createElement(
                'div',
                { className: 'circles' },
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto })
              )
            )
          ),
          _react2.default.createElement(
            'span',
            { className: 'point' },
            _react2.default.createElement(
              'div',
              { className: 'circlesAndIcon' },
              _react2.default.createElement('i', { className: '' }),
              _react2.default.createElement(
                'div',
                { className: 'circles' },
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto })
              )
            )
          ),
          _react2.default.createElement(
            'span',
            { className: 'point' },
            _react2.default.createElement(
              'div',
              { className: 'circlesAndIcon' },
              _react2.default.createElement('i', { className: '' }),
              _react2.default.createElement(
                'div',
                { className: 'circles' },
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto })
              )
            )
          ),
          _react2.default.createElement(
            'span',
            { className: 'point' },
            _react2.default.createElement(
              'div',
              { className: 'circlesAndIcon' },
              _react2.default.createElement('i', { className: '' }),
              _react2.default.createElement(
                'div',
                { className: 'circles' },
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto }),
                _react2.default.createElement('span', { className: "circle photo" + this.state.currentPhoto })
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'resolutionPoints' },
          _react2.default.createElement(
            'div',
            { className: 'table' },
            _react2.default.createElement(
              'div',
              { className: 'cell' },
              _react2.default.createElement(
                'p',
                null,
                txtCase.resolution
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { onClick: this.state.currentPhoto < 3 ? this.nextPhoto.bind(this) : this.props.showConclusion, className: "nextView " + this.props.caseId },
            _react2.default.createElement(
              'span',
              null,
              buttonContinue
            ),
            _react2.default.createElement('i', { className: 'icon-arrowright' })
          )
        ),
        _react2.default.createElement(
          'span',
          { className: 'titleBottom elementToFadeOut' },
          this.props.titleBottom
        ),
        _react2.default.createElement('span', { id: 'wrongText', className: isWrong, dangerouslySetInnerHTML: { __html: wrongText } }),
        _react2.default.createElement(
          'div',
          { className: 'copyright' },
          txtCase.copyright
        )
      );
    }
  }]);
  return Find_Evidences;
}(_react2.default.Component), _class.contextTypes = {
  baseUrl: _react.PropTypes.string.isRequired,
  project: _react.PropTypes.string.isRequired
}, _temp);
exports.default = Find_Evidences;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Find_Evidences/Find_Evidences.js
// module id = 791
// module chunks = 0